import React, { useState, useEffect } from 'react';
import { getMarkDown } from '../utils';
import '../../../stylesheets/triagebot/Range.scss';
import '../../../stylesheets/triagebot/RangeOpenCDO.scss';

const cdoName = process.env.REACT_APP_CDO_NAME;

const RangeMessage = ({ message, sendMessage, npsValue, setNpsValue, disabled }) => {
    const [windowWidth, setWindowWidth] = useState(0);

    const isSmallMobile = (windowWidth <= 370);
    const isMobile = (windowWidth > 370 && windowWidth < 768);
    const isOpenCdo = (cdoName).toLowerCase() === 'open';

    const buttons = [];

    const RANGE = { min: 0, max: 10, step: 1, minText: '', maxText: '', ratingText:''}

    const range = (message && message.data && message.data.length && message.data[0])
        ? { ...RANGE, ...message.data[0] }
        : RANGE

    range.min = parseInt(range.min) || 0;

    range.max = parseInt(range.max) || 10;

    range.step = parseInt(range.step) || 1;

    const isDisabled = disabled;

    const updateWindowWidth = () => {
        setWindowWidth(window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth)
    }

    sendMessage = (typeof sendMessage === 'function')
        ? sendMessage
        : () => { }

    useEffect(() => {
        window.addEventListener('resize', updateWindowWidth);
        updateWindowWidth();
        return () => window.removeEventListener('resize', updateWindowWidth);
    }, [])

    for (let i = range.min; i <= range.max; i += range.step)
        buttons.push(
            <button
                key={'value' + i}
                onClick={() => handleButtonClick(i)}
                className={i === npsValue ? "selected tick" : "tick"}
                disabled={isDisabled}
                id={'button-range-' + i}
                role='radio'
                aria-checked={i === npsValue ? 'true' : 'false'}
                aria-label={`Rating ${i}`}
                tabIndex={i === npsValue ? 0 : -1}
            >
                {i}
            </button>);
    
    const handleButtonClick = (selection) => {
        setNpsValue(selection);
    }
    
    return (
        <div className={isDisabled ? 'submitted rangecard' : 'rangecard'} id='NpsRating'>
            <div className='header' style= {{ color : `var(--primary-color)` }} id='nps-range-card'>
                <h2 className='headerText' >{getMarkDown(message)}</h2>
            </div>
            {
                isMobile
                    ?
                    <div className={isOpenCdo ? 'mobile range open-cdo' : 'mobile range'} role='radiogroup' aria-labelledby='nps-range-card'>
                        {isOpenCdo && (
                            <div className="labels open-cdo">
                                <div className="label">{range.min}={range.minText}</div>
                                <div className="label">{range.max}={range.maxText}</div>
                            </div>
                        )}
                        {isOpenCdo ? (
                            <div className='mobile buttons open-cdo-wrap'>
                                {buttons}
                            </div>
                        ) : (
                            <>
                                <div className='mobile buttons'>
                                    {
                                        buttons.map((button, i) => {
                                            if (i < 5) return button
                                        })
                                    }
                                </div>
                                <div className='mobile buttons'>
                                    {
                                        buttons.map((button, i) => {
                                            if (i >= 5 && i <= 9) return button
                                        })
                                    }
                                </div>
                                <div className='mobile buttons'>
                                    {
                                        buttons.map((button, i) => {
                                            if (i === 10) return button
                                        })
                                    }
                                </div>
                            </>
                        )}
                        {!isOpenCdo && (
                            <div className="mobile label">
                                {range.ratingText}
                            </div>
                        )}
                    </div>
                    :
                    isSmallMobile
                    ?
                        <div className={isOpenCdo ? 'mobile range open-cdo' : 'mobile range'} role='radiogroup' aria-labelledby='nps-range-card'>
                            {isOpenCdo && (
                                <div className="labels open-cdo">
                                    <div className="label">{range.min}={range.minText}</div>
                                    <div className="label">{range.max}={range.maxText}</div>
                                </div>
                            )}
                            {isOpenCdo ? (
                                <div className='mobile buttons open-cdo-wrap'>
                                    {buttons}
                                </div>
                            ) : (
                                <>
                                    <div className='mobile buttons'>
                                        {
                                            buttons.map((button, i) => {
                                                if (i < 3) return button
                                            })
                                        }
                                    </div>
                                    <div className='mobile buttons'>
                                        {
                                            buttons.map((button, i) => {
                                                if (i > 2 && i < 7) return button
                                            })
                                        }
                                    </div>
                                    <div className='mobile buttons'>
                                        {
                                            buttons.map((button, i) => {
                                                if (i > 6) return button
                                            })
                                        } 
                                    </div>
                                </>
                            )}
                            {!isOpenCdo && (
                                <div className="mobile label">
                                    {range.ratingText}
                                </div>
                            )}
                        </div>
                        :  
                        <div className={isOpenCdo ? 'range open-cdo-desktop' : 'range'} >
                            {isOpenCdo ? (
                                <>
                                    <div className='labels open-cdo'>
                                        <div className="label">{range.min}={range.minText}</div>
                                        <div className="label">{range.max}={range.maxText}</div>
                                    </div>
                                    <div className='buttons open-cdo-desktop' role='group' aria-labelledby='nps-range-card'>
                                        {buttons}
                                    </div>
                                </>
                            ) : (
                                <>
                                    <div className='buttons' role='radiogroup' aria-labelledby='nps-range-card'>
                                        {buttons}
                                    </div>
                                    <div className='labels'>
                                        <div className="min label">{range.minText}</div>
                                        <div className="max label">{range.maxText}</div>
                                    </div>
                                </>
                            )}
                        </div>
            }
            {/* <Footer>
                <button
                    className='submit-button button-width-next'
                    onClick={() => buttonPress()}
                >
                    Next
                </button>
            </Footer> */}
        </div >);
};

export default RangeMessage;